package net.bothosting.docs.components.ui

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

@Composable
fun BrandText(modifier: Modifier = Modifier) {
    SpanText(
        "BOT-HOSTING.NET",
        modifier
            .fontSize(0.85.cssRem)
            .fontWeight(FontWeight.Bold)
            .letterSpacing(0.025.em)
            .color(Color.rgb(0xffffff))
    )
}
